export default __webpack_public_path__ + "static/logo-full-light-72b8829728fc2d5f085bf01ac0aa7e18.png";